import { useState, useEffect } from 'react';
import api from '../../services/api'; // ✅ Ruta correcta desde admin/AdminDashboard
import { Users, PawPrint, QrCode, MapPin, Phone, ClipboardList, Store, Package } from 'lucide-react';

const StatCard = ({ icon: Icon, label, value, color }) => (
  <div className="sp-card admin-stat-card">
    <div className="admin-stat-icon">
      <Icon size={28} style={{ color }} />
    </div>
    <div className="admin-stat-value">{value}</div>
    <div className="admin-stat-label">{label}</div>
  </div>
);

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    usuarios: 0,
    mascotas: 0,
    codigos: 0,
    ubicaciones: 0,
    contactos: 0,
    historial: 0,
    socios: 0,
    productos: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const endpoints = [
          'usuarios',
          'mascotas',
          'codigos',
          'ubicaciones',
          'contactos',
          'historial',
          'socios',
          'productos',
        ];

        // Hacemos todas las peticiones en paralelo
        const responses = await Promise.all(
          endpoints.map((endpoint) =>
            api.get(`/${endpoint}`).catch((err) => {
              console.warn(`Error obteniendo /${endpoint}:`, err.response?.status);
              return { data: { data: [] } }; // fallback silencioso
            })
          )
        );

        // Extraemos totales
        const newStats = {};
        responses.forEach((res, i) => {
          const resource = endpoints[i];
          const payload = res.data;
          // La API puede devolver { data: [...] } o directamente un array
          const dataArray = Array.isArray(payload?.data) ? payload.data : (Array.isArray(payload) ? payload : []);
          newStats[resource] = dataArray.length;
        });

        setStats((prev) => ({ ...prev, ...newStats }));
      } catch (err) {
        console.error('Error cargando estadísticas:', err);
        setError('No se pudieron cargar las estadísticas.');
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  if (loading) {
    return <div className="sp-card"><p>Cargando estadísticas...</p></div>;
  }

  if (error) {
    return <div className="sp-card sp-card--danger"><p>{error}</p></div>;
  }

  return (
    <div>
      <div className="admin-section-header">
        <h1>Panel de Administración</h1>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: '1rem' }}>
        <StatCard icon={Users} label="Usuarios" value={stats.usuarios} color="#4e3f7f" />
        <StatCard icon={PawPrint} label="Mascotas" value={stats.mascotas} color="#d16fa3" />
        <StatCard icon={QrCode} label="Códigos QR" value={stats.codigos} color="#5b4a8b" />
        <StatCard icon={MapPin} label="Ubicaciones" value={stats.ubicaciones} color="#16a34a" />
        <StatCard icon={Phone} label="Contactos" value={stats.contactos} color="#d97706" />
        <StatCard icon={ClipboardList} label="Historial" value={stats.historial} color="#0ea5e9" />
        <StatCard icon={Store} label="Socios" value={stats.socios} color="#8b5cf6" />
        <StatCard icon={Package} label="Productos" value={stats.productos} color="#ec4899" />
      </div>
    </div>
  );
};

export default AdminDashboard;